'use client';

import React from 'react';
import HeatMap, { ActivityPoint } from './HeatMap';
import StatCard from './StatCard';
import { Card, CardHeader, CardContent } from './ui/card';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

type ActivityCardProps = {
  eventCount: number;
  currentStreak: number;
  activity: ActivityPoint[];
};

const ActivityCard = (props: ActivityCardProps) => {
  const { eventCount, currentStreak, activity } = props;

  return (
    <Card className="w-full overflow-hidden">
      <CardHeader>
        <h2 className="h2 pb-0!">Activity</h2>
      </CardHeader>
      <CardContent>
        <StatCard
          text={`Current streak: ${currentStreak} ${currentStreak === 1 ? 'day' : 'days'}`}
          variant="info"
        />
        <StatCard
          text={`${eventCount} ${eventCount === 1 ? 'day' : 'days'} trained`}
          variant="info"
        />
        <Accordion type="single" collapsible>
          <AccordionItem value="item-1">
            <AccordionTrigger className="flex items-center justify-start">
              <StatCard text="Activity heatmap" variant="info" />
            </AccordionTrigger>
            <AccordionContent>
              <HeatMap data={activity} />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </CardContent>
    </Card>
  );
};

export default ActivityCard;
